import { Component } from 'preact'

import { api } from 'app/util/api'
import { ellipsis } from 'app/util'

export default class Tag extends Component {
  state = {
    loading: false,
    bookmarks: [],
  }

  componentDidMount() {
    this.findBookmarks()
  }

  async findBookmarks() {
    const { name } = this.props

    const bookmarks = await api.get(`/bookmark?tags[0]=${name}`)

    this.setState({ bookmarks })
  }

  renderList() {
    const { bookmarks } = this.state

    return bookmarks.map(b => (
      <div class="row">
        <div class="my-2 col">
          <span class="mr-2 text-muted">{b.relativeTime}</span>

          <a href={b.urlNormalized} class="text-dark" target="_blank" rel="noopener">
            {b.title}
          </a>
        </div>
      </div>
    ))
  }

  render() {
    const { name } = this.props
    const { bookmarks } = this.state

    return (
      <div>
        {/* <h3 class="mb-4">#{name}</h3> */}
        <h2 class="font-weight-bold">#{name}</h2>
        <div class="mb-4 text-muted">
          {bookmarks.length > 0 ? `${bookmarks.length} found` : null}
        </div>

        <div class="mb-3">{this.renderList()}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./pages/Tag.js